var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgNavDrawerClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "img-navDrawer--close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "img-navDrawer--close",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,-1 L9,7 L17,7 L17,8 L9,8 L9,16 L8,16 L8,8 L0,8 L0,7 L8,7 L8,-1 L9,-1 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    transform: "translate(8.500000, 7.500000) rotate(45.000000) translate(-8.500000, -7.500000) "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgNavDrawerClose);
export default __webpack_public_path__ + "static/media/img-navDrawer--close.0cb02201b489ea8311c1154815482b53.svg";
export { ForwardRef as ReactComponent };